(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity/assets/jotai/charity-atoms.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity/assets/jotai/charity-atoms.js');
"use strict";

var _svs$lyckoplatsen$dat, _svs$lyckoplatsen$dat2;

const _jotai = jotai,
  atom = _jotai.atom;
const atomWithSvSStorage = svs.lyckoplatsen.shared_utils.atomWithSvSStorage;
const activeCharities = (_svs$lyckoplatsen$dat = (_svs$lyckoplatsen$dat2 = svs.lyckoplatsen.data) === null || _svs$lyckoplatsen$dat2 === void 0 ? void 0 : _svs$lyckoplatsen$dat2.activeCharities) !== null && _svs$lyckoplatsen$dat !== void 0 ? _svs$lyckoplatsen$dat : [];
const wager = svs.lyckoplatsen.data.preloadedWager;
const hasWager = Boolean(wager);
const storageKeySuffix = hasWager ? "-".concat(wager.wagerId) : '';
let charity = null;
if (hasWager) {
  const hasCharity = Boolean(wager.wager.bets[0].geoBoardData.charityId);
  if (hasCharity) {
    const activeCharity = activeCharities.find(activeCharity => activeCharity.charityId === wager.wager.bets[0].geoBoardData.charityId);
    if (activeCharity) {
      charity = activeCharity;
    } else {
      svs.lyckoplatsen.components.shared_charity.utils.showWrongCharityDialog();
    }
  }
}
const atoms = {
  charityAtom: atomWithSvSStorage("charity".concat(storageKeySuffix), charity),
  activeCharitiesAtom: atom(() => activeCharities)
};
setGlobal('svs.lyckoplatsen.shared_charity.jotai', {
  atoms
});

 })(window);